/**
 * 마법사의 MARS 설정 기본값 — 화면이 보여 주는 값이자 생성이 저장하는 값(#420: 표시만 기본값이고 저장은 비어 있던 사고).
 */
import type { MARSConfig } from '@/types/project';

export const DEFAULT_MARS_CONFIG: Readonly<MARSConfig> = Object.freeze({
  problemType: 'NEW',
  problemOption: 'TRANSNT',
});
